import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "src/@/components/ui/dialog";
import { Button } from "src/@/components/ui/button";
import { Input } from "src/@/components/ui/input";
import { RowInput } from "src/components/forms/RowInput";
import { Label } from "src/@/components/ui/label";

const CORES_PREDEFINIDAS = [
  { valor: '#ef4444', nome: 'Vermelho' },
  { valor: '#f59e0b', nome: 'Amarelo' },
  { valor: '#22c55e', nome: 'Verde' },
  { valor: '#3b82f6', nome: 'Azul' },
  { valor: '#8b5cf6', nome: 'Violeta' },
  { valor: '#ec4899', nome: 'Rosa' },
  { valor: '#f97316', nome: 'Laranja' },
  { valor: '#06b6d4', nome: 'Ciano' },
  { valor: '#6b7280', nome: 'Cinza' },
  { valor: '#7C3AED', nome: 'Roxo' },
  { valor: '#dc2626', nome: 'Vermelho Escuro' },
];

export default function ModalPrioridadeChamado({
  open,
  onClose,
  onSubmit,
  action,
  titulo,
  changeTitulo,
  cor,
  changeCor,
  tempoAceite,
  changeTempoAceite,
  tempoConclusao,
  changeTempoConclusao,
}) {
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[480px]">
        <DialogHeader>
          <DialogTitle>
            {action === "Criar" ? "Nova Prioridade" : "Editar Prioridade"}
          </DialogTitle>
        </DialogHeader>
        <div className="grid gap-4 py-4">
          <RowInput
            label="Titulo"
            input={
              <Input
                onChange={changeTitulo}
                value={titulo}
                placeholder="Ex: Critica"
              />
            }
          />
          <div>
            <Label className="block text-xs font-semibold text-gray-500 uppercase tracking-wider mb-3">
              Cor
            </Label>
            <div className="flex flex-wrap gap-2">
              {CORES_PREDEFINIDAS.map((c) => (
                <button
                  key={c.valor}
                  type="button"
                  onClick={() => changeCor(c.valor)}
                  className={`w-8 h-8 rounded-full border-2 transition-all ${
                    cor === c.valor
                      ? 'border-gray-900 scale-110 shadow-md'
                      : 'border-transparent hover:border-gray-300'
                  }`}
                  style={{ backgroundColor: c.valor }}
                  title={c.nome}
                />
              ))}
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4">
            <RowInput
              label="Tempo de Aceite (min)"
              input={
                <Input
                  type="number"
                  onChange={changeTempoAceite}
                  value={tempoAceite}
                  placeholder="Ex: 30"
                  min={0}
                />
              }
            />
            <RowInput
              label="Tempo de Conclusao (min)"
              input={
                <Input
                  type="number"
                  onChange={changeTempoConclusao}
                  value={tempoConclusao}
                  placeholder="Ex: 120"
                  min={0}
                />
              }
            />
          </div>

          {/* Preview */}
          <div className="pt-2">
            <Label className="text-sm text-gray-600 mb-2 block">Preview</Label>
            <div className="flex items-center gap-2 p-3 border border-gray-200 rounded-md bg-gray-50">
              <span
                className="w-2.5 h-2.5 rounded-full"
                style={{ backgroundColor: cor }}
              />
              <span className="text-sm font-medium text-gray-900">
                {titulo || 'Nome da prioridade'}
              </span>
            </div>
          </div>
        </div>
        <DialogFooter>
          <Button onClick={onSubmit}>
            {action === "Criar" ? "Criar" : "Salvar"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
